module.exports = __webpack_public_path__ + "img/bmw1.8e3cc47b.png";